const object = (value) => value && typeof value === 'object' && !Array.isArray(value) ? value : {};
const array = (value) => Array.isArray(value) ? value : [];
const text = (value) => typeof value === 'string' ? value : '';

const emptyProjection = () => ({
  is_visible: false, run_id: '', status: '', current_step: null, steps: [], events: [],
  execution_ledger: {}, progress: {}, blocked: {}, human_confirmation: {}, artifact: {},
});

/** Adapt the accepted backend snapshot to Canvas props; events never select state. */
export function selectCanvasWorkflowProjection(workflowProjection) {
  const source = object(workflowProjection);
  const hasPreparedProgress = Object.hasOwn(source, 'progress_projection');
  const prepared = object(source.progress_projection);
  const steps = array(hasPreparedProgress ? prepared.steps : source.run_steps);
  const status = text(hasPreparedProgress ? prepared.status : source.run_state);
  const explicitCurrentStep = object(source.current_step);
  const currentStep = hasPreparedProgress
    ? steps.find((step) => text(step?.step_id) && step.step_id === prepared.current_step_id) ?? null
    : Object.keys(explicitCurrentStep).length ? explicitCurrentStep : null;
  if (!status && !steps.length && !currentStep) return emptyProjection();
  return {
    is_visible: true,
    run_id: text(source.run_id),
    status,
    current_step: currentStep,
    steps,
    events: array(source.run_events),
    execution_ledger: object(source.execution_ledger),
    progress: object(prepared.progress),
    blocked: object(source.blocked),
    human_confirmation: object(source.human_confirmation),
    artifact: object(source.active_artifact),
  };
}

export default selectCanvasWorkflowProjection;
